// ReceiptChannelTable.js
import { useState, useEffect } from 'react';
import api from '../../../services/api';

const ReceiptChannelTable = ({assessments, fieldOptions }) => {
  // Создаем маппинг option_value -> массив оценок
  const assessmentsByChannel = {};

  // Инициализируем маппинг для каждого option_value
  fieldOptions.forEach(option => {
    assessmentsByChannel[option.option_value] = [];
  });

  // Распределяем оценки по каналам поступления
  assessments.forEach(assessment => {
    const receiptChannel = assessment.receipt_channel;
    if (receiptChannel && assessmentsByChannel[receiptChannel]) {
      assessmentsByChannel[receiptChannel].push(assessment);
    }
  });
  // Формируем статистику из маппинга
  const stats = Object.entries(assessmentsByChannel).map(([optionValue, assessmentsList]) => {
    // Находим соответствующий option_text
    const option = fieldOptions.find(opt => opt.option_value === optionValue);
    const channelName = option ? option.option_text : optionValue;
    
    const totalCount = assessmentsList.length;
    
    // Считаем количество критериев с score = 0
    const zeroScoreCount = assessmentsList.reduce((count, assessment) => {
      if (assessment.items && Array.isArray(assessment.items)) {
        return count + assessment.items.filter(item => item.score === 0).length;
      }
      return count;
    }, 0);
    
    const percentage = totalCount > 0 ? ((zeroScoreCount / totalCount) * 100).toFixed(1) : '0.0';
    
    return {
      channelName,
      totalCount,
      zeroScoreCount,
      percentage
    };
  });

  // Добавляем "Без канала" если есть оценки без канала поступления
  const assessmentsWithoutChannel = assessments.filter(a => !a.receipt_channel);
  if (assessmentsWithoutChannel.length > 0) {
    const zeroScoreCount = assessmentsWithoutChannel.reduce((count, assessment) => {
      if (assessment.items && Array.isArray(assessment.items)) {
        return count + assessment.items.filter(item => item.score === 0).length;
      }
      return count;
    }, 0);
    
    const percentage = assessmentsWithoutChannel.length > 0 ? 
      ((zeroScoreCount / assessmentsWithoutChannel.length) * 100).toFixed(1) : '0.0';
    
    stats.push({
      channelName: 'Без канала',
      totalCount: assessmentsWithoutChannel.length,
      zeroScoreCount,
      percentage
    });
  }

  // Сортируем по общему количеству (по убыванию)
  const sortedStats = stats.sort((a, b) => b.totalCount - a.totalCount);
    // Убираем проверку loading, так как мы получаем assessments из props
  // и можем отображать таблицу сразу
  

  // Убираем проверку error, так как мы не делаем API-запросы в этом компоненте
  // и получаем все данные через props
  

  return (
    <div className="table-wrapper">
      <h3>Статистика по каналам поступления</h3>
      <table className="stats-table">
        <thead>
        <tr>
          <th>Канал поступления</th>
          <th>Количество проверок</th>
          <th>Количество ошибок</th>
          <th>% ошибок</th>
        </tr>
        </thead>
        <tbody>
        {sortedStats.map((stat) => (
            <tr key={stat.channelName}>
              <td>{stat.channelName}</td>
              <td>{stat.totalCount}</td>
              <td>{stat.zeroScoreCount}</td>
              <td>{stat.percentage}%</td>
            </tr>
        ))}
        {sortedStats.length === 0 && (
            <tr>
              <td colSpan="4" style={{textAlign: 'center'}}>Нет данных для отображения</td>
            </tr>
        )}
        </tbody>
        <tfoot>
          <tr style={{backgroundColor: '#f5f5f5', fontWeight: 'bold'}}>
            <td>Grand Total</td>
            <td>{sortedStats.reduce((sum, stat) => sum + stat.totalCount, 0)}</td>
            <td>{sortedStats.reduce((sum, stat) => sum + stat.zeroScoreCount, 0)}</td>
            <td>{
              sortedStats.length > 0
                  ? ((sortedStats.reduce((sum, stat) => sum + stat.zeroScoreCount, 0) / sortedStats.reduce((sum, stat) => sum + stat.totalCount, 0)) * 100).toFixed(1)
                  : '0.0'
            }%
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default ReceiptChannelTable;